export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

export function scrollToTarget(targetById, offset = 0) {
  const element = document.getElementById(targetById)
  const elementPosition = element.getBoundingClientRect().top
  const offsetPosition = elementPosition + offset

  window.scrollBy({
    top: offsetPosition,
    behavior: 'smooth'
  })
}
